export default {
  install(Vue) {
    Vue.prototype.$exportExcel = function (data, headers, fileName) {
      const ExportJsonExcel = require('js-export-excel')
      var option = {}
      option.fileName = fileName
      option.datas = [{
        sheetData: data,
        sheetName: 'sheet',
        // sheetFilter: ['one', 'two'],
        sheetHeader: headers
      }]
      var toExcel = new ExportJsonExcel(option)
      toExcel.saveExcel()
    }
  }
}